
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-0accc11c&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./shopcomment.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./shopcomment.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-0accc11c!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./shopcomment.vue"),
  /* scopeId */
  "data-v-0accc11c",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/staging/shopcomment.vue
// module id = 1581
// module chunks = 3